export const PrivateMobileFirst = () => {
    return (
        <div className="relative h-[385px] min-h-[385px] pt-[66px] [background:linear-gradient(135deg,rgba(255,255,255,1)_0%,rgba(184.71,199.94,255,1)_34.641%,rgba(59,224.75,254,1)_100%)]">
            <div className="h-[124px]  flex px-[38px] ">
                <div className="flex-1 ">
                    <div className="text-[10px] font-regular text-white w-[226.8px] h-[23.2px] flex flex-row justify-start items-center gap-[4.8px] px-[4px] py-[1.6px] rounded-[4px] [background:linear-gradient(90deg,rgba(97,155,255,1),rgba(198,225,255,0)_100%)]">
                        光年自建K-WAN组网解决方案
                    </div>
                    <div className="mt-[7px] justify-start text-[rgba(51,51,51,1)]  text-[16px] font-medium ">
                        企业私有化组网
                        <br />
                    </div>

                    <div className="text-[rgba(51,51,51,1)] text-[10px] font-regular mt-[3px]">根据出海企业的业务需求，定制高性价比的专属全球网络连接方案，组建自己的全球专用内部互联网络，实现跨国分支机构异地数据互通互联，支持后期拓展定制</div>
                    <div className="mt-[10px] flex flex-col gap-[12px]">
                        <a href="https://t22qshgkpd.jiandaoyun.com/f/68cb68e880eabb692970b84a" target="_blank" rel="noreferrer noopener">
                            {/* <div className="w-[84px] h-[28px] flex flex-row justify-center items-center px-[8.29px] py-[3.46px] rounded-[3.32px] [background:linear-gradient(135deg,rgba(100,183,255,1)_0%,rgba(137,171,255,1)_53.907%,rgba(185,155,255,1)_100%)]2 text-white text-[8px] font-medium ">立即咨询</div> */}
                            <div
                                className="w-[71.04px] h-[25px] flex flex-row justify-center items-center gap-[4.8px]  py-[4px] rounded-[3.84px]
    [background:linear-gradient(135deg,rgba(100,183,255,1)_0%,rgba(137,171,255,1)_53.907%,rgba(185,155,255,1)_100%)]"
                            >
                                <span className="text-white text-[12px] font-medium">立即咨询</span>
                            </div>
                        </a>


                    </div>
                </div>
                <div className="absolute right-[30px] bottom-[50px] pointer-events-none">
                    <img src={"/imgs/private/1.png"} className="h-[165px] w-[165px] " />

                </div>
            </div>

        </div>
    );
};